import * as React from 'react';
import {ScheduleItemStatus} from './components/ScheduleItem';
import {IconCheck, IconHoliday, IconLock, IconLockOpened} from 'icons';
import {ChapterContentObject, ChapterContentType} from "api/course";
import {getLessonByID} from "api/lesson/requests";
import {LessonObject} from "api/lesson/types";
import {getWebinarByID} from "api/webinar/requests";
import {WebinarObject} from "api/webinar/types";
import isError from "helpers/isError";
import validateResponse from "helpers/validate-response";
import {ErrorObject} from "types";

/**
 * the function return course schedule item status icon
 * @param {ScheduleItemStatus} status
 * @return {React.ReactElement}
 * @constructor
 */
export function renderScheduleItemIcon(status: ScheduleItemStatus) {
  switch (status) {
    case ScheduleItemStatus.Closed:
      return (<IconLock />);
    case ScheduleItemStatus.Opened:
      return (<IconLockOpened />);
    case ScheduleItemStatus.Complete:
      return (<IconCheck />);
    case ScheduleItemStatus.isRest:
      return (<IconHoliday />);
  }
}

/**
 * the function return course schedule item status icon
 * @param {ScheduleItemStatus} status
 * @return {React.ReactElement}
 * @constructor
 */
export function getScheduleItemActiveProp(status: ScheduleItemStatus) {
  switch (status) {
    case ScheduleItemStatus.Closed:
      return false;
    case ScheduleItemStatus.Opened:
      return true;
    case ScheduleItemStatus.Complete:
      return true;
    case ScheduleItemStatus.isRest:
      return true;
  }
}

/**
 * return Lesson from chapter content object
 * @param {ChapterContentObject} chapter
 * @return {Promise}
 * @constructor
 */
export function chaptersGetLesson(chapter: ChapterContentObject) {
  if (chapter.type === ChapterContentType.Lesson) {
    return getLessonByID(chapter.instanceId)
  }
}

/**
 * return Webinar from chapter content object
 * @param {ChapterContentObject} chapter
 * @return {Promise}
 * @constructor
 */
export function chaptersGetWebinar(chapter: ChapterContentObject) {
  if (chapter.type === ChapterContentType.Webinar) {
    return getWebinarByID(chapter.instanceId)
  }
}

// /**
//  * return Task from chapter content object
//  * @param {ChapterContentObject} chapter
//  * @return {Promise}
//  * @constructor
//  */
// export function chaptersGetTask(chapter: ChapterContentObject) {
//   if (chapter.type === ChapterContentType.Task) {
//     return getTaskById(chapter.instanceId)
//   }
// }

/**
 *
 * @param {ChapterContentObject} response
 * @return {Promise}
 * @constructor
 */
export function validateAndGetLessons(
  response: (LessonObject | ErrorObject | undefined)[]
) {
  const result: LessonObject[] = [];

  Array.isArray(response) && response.forEach((responseItem) => {
    validateResponse(responseItem);
    if (responseItem && !isError(responseItem)) {
      result.push(responseItem);
    }
  });

  return result.filter(Boolean);
}

/**
 *
 * @param {ChapterContentObject} response
 * @return {Promise}
 * @constructor
 */
export function validateAndGetWebinars(
  response: (WebinarObject | ErrorObject | undefined)[]
) {
  const result: WebinarObject[] = [];

  Array.isArray(response) && response.forEach((responseItem) => {
    validateResponse(responseItem);
    if (responseItem && !isError(responseItem)) {
      result.push(responseItem);
    }
  });

  return result.filter(Boolean);
}
